import { ProposalDto } from '../../types/spool-local';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';
import { sleep } from '../../../web3/utils';
import useLatestProposal from './useLatestProposal';

const useProposalVotingResult = () => {
    const { interfaceSDK } = useContext(appContext);

    const { latestProposal } = useLatestProposal();

    const { data, error, mutate } = useSWR(
        interfaceSDK && latestProposal ? ['proposalVotingResult', latestProposal] : null,
        async (_, latestProposal: ProposalDto) =>
            interfaceSDK?.get.getProposalVotingResult(latestProposal.id)
    );

    const update = async (previousValue?: number) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            if (currentValue?.absolute) {
                const currentTotalVotes = Object.values(currentValue?.absolute).reduce(
                    (acc, cur) => (acc += cur),
                    0
                );

                if (currentTotalVotes !== previousValue) {
                    break;
                }
            }
            retries++;
            await sleep(3000);
        } while (retries < 5);
    };

    return {
        proposalVotingResult: data,
        isLoading: !error && !data,
        error,
        updateProposalVotingResult: update,
    };
};

export default useProposalVotingResult;
